import FEATURE_TYPE from './FEATURE_TYPE';

/** @deprecated All new features should use accountFeature instead */
const appFeature = (value, defaultConfig, { evalOnUpdate = true } = {}) => ({
  type: FEATURE_TYPE.APP,
  value,
  defaultConfig,
  evalOnUpdate,
});
const accountFeature = (value, defaultConfig, { evalOnUpdate = true } = {}) => ({
  type: FEATURE_TYPE.ACCOUNT,
  value,
  defaultConfig,
  evalOnUpdate,
});

export default {
  AGORA: accountFeature(
    'GXP-1805__account__agora',
    {
      enabled: false,
      events: {},
      lowStream: { width: 640, height: 360, framerate: 15, bitrate: 300 },
    },
    { evalOnUpdate: false }
  ),
  APP_CONFIG: appFeature('PORT-2263__app__config', {
    versions: {
      studio: '',
      guest: '',
    },
  }),
  CHAT: accountFeature('SPLIT-9__chat__account', {
    enabled: true,
    allowSend: true,
    guest: {
      shouldLoadHistory: false,
    },
    studio: {
      shouldLoadHistory: true,
    },
  }),
  COMPOSITE_TARGET: accountFeature('SPLIT-20__composite-target', {
    enabled: false,
    options: [
      {
        value: 'headless-sandbox',
        text: 'Headless Dev',
        url: 'https://d23iyp9qvx0akg.cloudfront.net/dist/index.html',
        default: true,
        debug: 0,
      },
      {
        value: 'composer-sb4',
        text: 'Composer (devs only)',
        url: 'https://sb4.socialive.us/index.html',
        default: false,
        debug: 0,
      },
    ],
  }),
  EXPORT_VIDEO: accountFeature('SPLIT-5__export-video__account', {
    enabled: true,
    types: {
      mp3: {
        enabled: true,
        ratio: 0.1,
        order: 1,
      },
      mp4: {
        enabled: true,
        ratio: 0.25,
        order: 2,
      },
      srt: {
        enabled: false,
        ratio: 0.25,
        order: 3,
      },
      transcript: {
        enabled: false,
        ratio: 0.25,
        order: 4,
      },
      vtt: {
        enabled: false,
        ratio: 0.25,
        order: 5,
      },
    },
  }),
  GUEST_LINKS: accountFeature('STUD-5072__account__guest-links'),
  HEALTH_INDICATOR: accountFeature('SPLIT-19__health-indicator', {
    type: 'bars',
    displayLimitation: false,
    displayBitrate: false,
  }),
  HYBRID_DETECTION: accountFeature('SPLIT-17__hybrid-detection', { enabled: false }),
  ICE_RESTART: accountFeature('GXP-1756__account__ice-restart', {
    publisher: {
      enabled: true,
      abort: true,
      abortStudio: false,
      wait: 0,
      showRestartToast: true,
    },
    subscriber: {
      enabled: true,
      abort: true,
      abortStudio: true,
      wait: 0,
      connectingTimeout: 3_000,
      maxRetries: 30,
    },
  }),
  JANUS_HANDLE_HEALTH: accountFeature('SPLIT-12__janus-handle-health__account', {
    broker: false,
    dataChannel: true,
  }),
  LOCAL_RECORDING: accountFeature(
    'GXP-1167__account__local-recording',
    {
      allowRecord: true,
      allowDownload: true,
      allowRetry: false,
      allowDelete: false,
      autoDelete: false,
      multiBroadcast: false,
      setMimeType: true,
      setBitRates: true,
    },
    { evalOnUpdate: false }
  ),
  MEDIA_UPLOAD: accountFeature('SPLIT-18__media-upload', {
    enabled: false,
  }),
  NAMETAG_OPTIONS: accountFeature('STUD-4857__account__nametag-options', {
    displayPronouns: true,
    nametagHideWidth: 0.2,
    sizing: [
      { value: 0.7, coefficient: 1.9, basedOn: 'width', maxWidth: 0.75, minScale: 0.35, maxWidthCoefficient: 0.7 },
      { value: 1.7, coefficient: 1.04, basedOn: 'height', maxWidth: 0.75, minScale: 0.35, maxWidthCoefficient: 0.7 },
      { value: 5, coefficient: 1.3, basedOn: 'width', maxWidth: 0.75, minScale: 0.35, maxWidthCoefficient: 0.7 },
      // acts like default range, can't use null due to sorting
      { value: 10000, coefficient: 0.26, basedOn: 'height', maxWidth: 0.75, minScale: 0.35, maxWidthCoefficient: 0.7 },
    ],
    // the order of this object defines the sort order in the dropdown
    templates: [
      { id: 1, name: 'Edge', imagePath: '/img/assets/nametags/nametag-edge.svg' },
      { id: 2, name: 'Basic', imagePath: '/img/assets/nametags/nametag-basic.svg' },
      { id: 4, name: 'Block', imagePath: '/img/assets/nametags/nametag-block.svg' },
      { id: 3, name: 'Line', imagePath: '/img/assets/nametags/nametag-line.svg' },
    ],
  }),
  PUBLISHERS: accountFeature('SPLIT-11__publishers__account', {
    enabled: false,
    maxPublishers: 20,
    maxUsers: 20,
  }),
  RENDITION_TARGET_STREAM: accountFeature('SPLIT-22__rendition-target-stream', {
    enabled: false,
  }),
  RESTART_ISO_RECORDING: accountFeature('SPLIT-21__restart-iso-recording', {
    enabled: true,
  }),
  RESTART_MONITOR: accountFeature('STUD-3601__account__restart-monitor', {
    guest: {
      enabled: false,
    },
    studio: {
      enabled: false,
      retryTimeout: 3_000,
    },
  }),
  SCENE_RENAME: accountFeature('STUD-4519__account__rename-scene', {
    maxLength: 75,
  }),
  SCENE_BADGE: accountFeature('SPLIT-39__scene_badge', {
    enabled: false,
    sceneList: {
      showBadge: false,
      tooltip: {
        text: '',
        offset: [0, 0],
      },
    },
  }),
  SCHEDULE_BROADCAST: accountFeature('SPLIT-45__schedule-broadcast', {
    enabled: false,
  }),
  SECURE_DOWNLOADS: accountFeature('SPLIT-6__secure-downloads__account'),
  SHOW_STREAM_STATE: accountFeature('STUD-4823__account__show-stream-state', {
    guest: {
      enabled: false,
      enabledStates: [],
    },
    studio: {
      enabled: false,
      enabledStates: ['disconnected', 'failed'],
    },
  }),
  SLIDES: accountFeature('GXP-1952__account__slides', {
    enabled: false,
    allowRename: false,
    allowHostControls: false,
    allowHostUpload: false,
  }),
  THEME_FONTS: accountFeature('SPLIT-23__theme-fonts', {
    allowLocalFonts: false,
  }),
  UNSTABLE_CONNECTION_TOAST: accountFeature('SPLIT-25__unstable-connection-toast', {
    lostTracks: {
      enabled: false,
      delay: 6_000,
      title: 'Unstable Internet Connection',
      message: `We stopped receiving your audio/video. Please ensure your connection is stable.`,
    },
  }),
  UPDATED_STUDIO_CHAT: accountFeature(
    'SPLIT-26__updated-studio-chat',
    {
      enabled: false,
    },
    { evalOnUpdate: false }
  ),
  USER_ROLES: accountFeature('SPLIT-15__user-roles', {
    enabled: false,
    GUEST: true,
    CONTRIBUTOR: true,
    CREATOR: true,
    PRODUCER: true,
    BROADCASTER: true,
    ADMIN: true,
  }),
  VIRTUAL_BACKGROUNDS: accountFeature('SPLIT-40__virtual-backgrounds', {
    enabled: false,
  }),
  SOLO_RECORDER: accountFeature('SPLIT-24__solo-recorder', {
    enabled: false,
    camera: true,
    screen: false,
    cameraAndScreen: false,
  }),
  SPACES: accountFeature('SPLIT-43__Spaces', {
    enabled: false,
  }),
  SINGLE_DOMAIN: accountFeature('SPLIT-44__single-domain', {
    cutoverDate: false,
    cutoverMessage: 'Portal Must Reload',
  }),
};
